import { FC, ReactElement } from "react";
import { Card, Grid, Stack, Typography } from "@mui/material";
import { tokens } from "@/tokens";
import { formatNumberWithSuffix } from "@/utils";

interface IMetricsCardProps {
  metrics: {
    entryLines: number;
    ports: number;
    weeks: number;
    oldEntrySummaries: number;
    newEntrySummaries: number;
  };
}

const MetricsCard: FC<IMetricsCardProps> = ({ metrics }): ReactElement => {
  const metricsData = [
    { title: "Entry Lines", value: formatNumberWithSuffix(metrics.entryLines) },
    { title: "Ports", value: metrics.ports },
    { title: "Weeks", value: metrics.weeks },
    { 
      title: "Entry Summaries", 
      value: `${metrics.oldEntrySummaries} → ${metrics.newEntrySummaries}`,
      isEntrySummaries: true 
    }
  ];

  return (
    <Card sx={{ p: 3, height: "100%" }}>
      <Stack height="100%" justifyContent="space-between">
        <Typography
          variant="body1"
          fontFamily="Manrope"
          fontWeight={tokens.fontWeight.heavy}
          color={tokens.text.primary}
          fontSize={tokens.fontSize.xl}
        >
          FTZ Metrics
        </Typography>
        <Grid container spacing={1.5}>
          {metricsData.map(({ title, value, isEntrySummaries }, index) => (
            <Grid item xs={6} key={index}>
              <Stack
                width="100%"
                height="100%"
                borderRadius={tokens.radius.sm}
                p={1.5}
                sx={{
                  backgroundColor: `${tokens.brand.primary}1A`,
                }}
              >
                <Typography
                  variant="caption"
                  fontFamily="Manrope"
                  fontWeight={tokens.fontWeight.bold}
                  sx={{ color: tokens.text.secondary }}
                >
                  {title}
                </Typography>
                <Typography
                  variant="h3"
                  fontSize={isEntrySummaries ? 20 : 24}
                  fontWeight={tokens.fontWeight.heavy}
                  color={tokens.text.primary}

                >
                  {value}
                </Typography>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Stack>
    </Card>
  );
};

export default MetricsCard; 